import { PageSizeSelector } from '@paytrace/pt-skel/Component'
import React from 'react'
import { Pagination } from './index'

const DEFAULT_PAGE_SIZES: number[] = [20, 50, 100, 200]

interface Props {
  page: number
  pageSize: number
  numberOfRecords: number
  numberOfPages?: number
  availablePageSizes?: number[]
  onPageSizeChange: (targetPageSize: number) => void
  onPageChange: (targetPage: number) => void
}

export function PaginationWithPageSelector (props: Props): React.JSX.Element {
  const {
    page,
    pageSize,
    numberOfRecords,
    numberOfPages = Math.max(1, Math.ceil(numberOfRecords / pageSize)), // Compute total pages on the fly if not provided
    availablePageSizes = DEFAULT_PAGE_SIZES,
    onPageChange,
    onPageSizeChange,
  } = props

  const currentStartTransaction = (page * pageSize) - (pageSize - 1)
  const currentEndTransaction = Math.min((page * pageSize), numberOfRecords)

  const paginationInfoMessage =
    numberOfRecords === 1
      ? 'Showing 1 of 1 transaction'
      : `Showing ${currentStartTransaction}–${currentEndTransaction} of ${numberOfRecords} transactions`

  return (
    <div className={'table-pagination-footer-bar'}>
      <div className={'page-size-selector-wrapper'}>
        <span>Show</span>
        <PageSizeSelector
          pageSize={props.pageSize}
          onPageSizeChange={onPageSizeChange}
          options={availablePageSizes}
        />
        <span>transactions per page</span>
      </div>
      <div className={'page-carousel-wrapper'}>
        <span className={'pagination-summary'}>
          {paginationInfoMessage}
        </span>
        <Pagination
          currentPage={page}
          totalPages={numberOfPages}
          onPageChange={onPageChange}
        />
      </div>
    </div>
  )
}
